import { EcheancesListPage } from './EcheancesListPage';

export function AEncaisserPage(): JSX.Element {
  return <EcheancesListPage sens="a_encaisser" />;
}
